import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="212.3859253" cy="169.7848816" r="0" />
				<path className="fill ear ear--right" d="M290.5451355,169.7881775c-2.3361206,21.0738831-22.9700623,56.9495697-35.4715271,55.5637512
					s-24.7771606-40.9096527-22.4410706-61.9835358s22.9700623-56.9495697,35.4714966-55.5637512
					C280.6054993,109.1904678,292.8811951,148.7142944,290.5451355,169.7881775z" />
				<path className="fill ear ear--left" d="M192.4631348,162.6876678c2.8315277,21.0130463-8.5103912,60.8148956-20.975769,62.4946136
					s-33.9381104-33.7003326-36.7696533-54.7133789c-2.8315277-21.0130463,8.5104065-60.814888,20.975769-62.494606
					C168.1588593,106.2945786,189.6315918,141.6746216,192.4631348,162.6876678z" />
				<g>
					<path className="fill" d="M286.1881409,219.7072754l-5.0021973-5.7351074
						c-1.6922607-1.9401855-0.404541-4.9775391,2.166748-5.1101074c2.6696777-0.1376953,2.9260254-3.2661133,2.0230713-5.263916
						s-6.1402588-12.1057129-6.1402588-12.1057129l-0.1136475,0.1938477
						c-0.8995361-26.2602539-8.5140381-40.614502-67.1086426-40.6149902
						c-58.5946045,0.0004883-66.2090454,14.3547363-67.1086426,40.6149902l-0.1137085-0.1938477
						c0,0-5.2373657,10.1079102-6.1401978,12.1057129c-0.9028931,1.9978027-0.6466064,5.1262207,2.0230713,5.263916
						c2.571228,0.1325684,3.8589478,3.1699219,2.166626,5.1101074l-5.0021362,5.7351074
						c-1.748291,2.0043945-0.5544434,5.1481934,2.0835571,5.4870605l2.6535645,0.3405762
						c2.2913208,0.2944336,3.4587402,2.9094238,2.1480103,4.8117676l-3.3581543,4.8737793
						c-1.4106445,2.0471191,0.0548706,4.8366699,2.5410767,4.8366699h0.3496094c2.3875732,0,3.8707275,2.5952148,2.6588135,4.6523438
						l-2.4741821,4.199707c-1.2119141,2.0571289,0.2712402,4.6523438,2.6587524,4.6523438h3.3988037
						c2.0338135,0,3.5115967,1.9333496,2.9776611,3.895752l-1.2531738,4.6069336
						c-0.5751953,2.114502,1.175293,4.1381836,3.350708,3.873291l3.6785889-0.447998
						c2.1174316-0.2578125,3.8515625,1.6589355,3.3837891,3.7399902l-0.3695068,1.644043
						c-0.4648438,2.0681152,1.2456055,3.9782715,3.3521729,3.7436523l25.7629395-3.2070312
						c7.4315186-0.4523926,14.8527832-1.314209,20.6345215-1.314209c5.7801514,0,13.197998,0.8613281,20.6264648,1.3139648
						l25.7658691,3.2072754c2.1064453,0.2346191,3.8168945-1.6755371,3.3520508-3.7436523l-0.3693848-1.644043
						c-0.4677734-2.0810547,1.2663574-3.9978027,3.3837891-3.7399902l3.6784668,0.447998
						c2.175415,0.2648926,3.9260254-1.7587891,3.3508301-3.873291l-1.2531738-4.6069336
						c-0.5339355-1.9624023,0.9437256-3.895752,2.9776611-3.895752h3.3986816c2.3875732,0,3.8707275-2.5952148,2.6588135-4.6523438
						l-2.4741211-4.199707c-1.2119141-2.0571289,0.2712402-4.6523438,2.6586914-4.6523438h0.3497314
						c2.4862061,0,3.9516602-2.7895508,2.5411377-4.8366699l-3.3581543-4.8737793
						c-1.310791-1.9023438-0.1434326-4.517334,2.1479492-4.8117676l2.6535645-0.3405762
						C286.7425842,224.8554688,287.9364319,221.7116699,286.1881409,219.7072754z" />
				</g>
				<g className="tongue">
					<path fill="#B45A60" d="M212.0106964,218.8930206c11.6897736,0,16.5278778-21.307312,16.5278778-21.307312
						s-4.8381042-3.6527863-16.5278473-3.6527863c-11.6897736,0-16.5278625,3.6527863-16.5278625,3.6527863
						S200.3209534,218.8930206,212.0106964,218.8930206z" />
					<path fill="#FC5959" d="M212.0108032,212.4672546c0,0,5.2467194-0.2916107,6.6537476,0.7509003
						c1.4070129,1.042511,2.3910828,3.3954468,3.1845551,5.0930023c0.7640686,1.6977234,1.3268738,3.3952789,1.7188721,5.0930023
						c0.3983612,1.6977234,0.6113434,3.3952789,0.5884399,5.0930023c-0.034256,1.6977234-0.2283325,3.3952942-0.9959717,5.0930023
						c-1.0226898,2.2077484-3.5506744,4.0912323-6.9941864,4.8355255c-1.0577698,0.2285919-3.1030121,0.3374329-4.1557312,0.3376312
						c-1.0527039-0.0001984-3.0979614-0.1090393-4.1557159-0.3376312c-3.4435272-0.7442932-5.9715118-2.6277771-6.9942017-4.8355255
						c-0.7676392-1.6977081-0.9617004-3.3952789-0.9959717-5.0930023c-0.0229034-1.6977234,0.1900787-3.3952789,0.5884399-5.0930023
						c0.3919983-1.6977234,0.9548035-3.3952789,1.7188873-5.0930023c0.793457-1.6975555,1.7775269-4.0504913,3.1845398-5.0930023
						C206.7635345,212.1756439,212.0102539,212.4672546,212.0108032,212.4672546z" />
				</g>
				<path className="fill" d="M246.249939,246.0572205c0,0-23.1636047,2.4571533-34.2392273,2.4571533
					s-34.2392273-2.4571533-34.2392273-2.4571533v-73.4789276h68.4784546V246.0572205z" />
				<path className="fill--face" d="M208.1399689,231.7178345h7.7414856c4.3008881,0,6.9536896,4.355423,4.7336426,7.771759l-2.0294189,3.1229858
					c-1.3891602,2.1376953-3.8838348,3.4446564-6.5750275,3.4446411l0,0c-2.6911316-0.0000305-5.1857605-1.3069763-6.5748749-3.4446259
					l-2.0294342-3.1229858C201.1862793,236.0732727,203.8390808,231.7178345,208.1399689,231.7178345z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/LilDoggo/Heads.js